import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';


const initialState = {
  isError: false,
  errorMsg: ''
};

// Async thunk
export const fetchFormQuestionsData = createAsyncThunk(
  'data/fetchData',
  async (_, thunkAPI) => {

  }
);

const errorConfig = createSlice({
  name: 'formConfig',
  initialState,
   reducers: {
    setErrorFlag: (state, action) => {
      state.isError = action.payload.isError;
      state.errorMsg = action.payload.errorMsg;

    },
  },
  extraReducers: (builder) => {
  },
});
export const { setErrorFlag } = errorConfig.actions;

export default errorConfig.reducer;
